import {
    SET_ITER_BUY_TO,
    SET_ITER_BUY_FROM,
    SET_ITER_SELL_TO,
    SET_ITER_SELL_FROM,
    SET_ORDER_ID_TO,
    SET_ORDER_ID_FROM,
    SET_TARG_IDX_TO,
    SET_TARG_IDX_FROM,
    SET_TXCNT_TO,
    SET_TXCNT_FROM,
    SET_AMOUNT_FOR_OPER_FROM,
    SET_AMOUNT_FOR_OPER_TO,
    SET_ORDER_AMOUNT_FOR_OPER_EXEC_FROM,
    SET_ORDER_AMOUNT_FOR_OPER_EXEC_TO,
    SET_ORDER_PRICE_FROM,
    SET_ORDER_PRICE_TO,
    SET_ORDER_ORIG_AMOUNT_FROM,
    SET_ORDER_ORIG_AMOUNT_TO,
    SET_ORDER_AMOUNT_FROM,
    SET_ORDER_AMOUNT_TO,
    SET_ORDER_EXEX_FROM,
    SET_ORDER_EXEX_TO,
    SET_FEE_RESULT_FROM,
    SET_FEE_RESULT_TO,
    SET_ORDER_REMAINS_FROM,
    SET_ORDER_REMAINS_TO,
    SET_FILTER_SIDE,
    SET_FILTER_STATUS,
    SET_FILTER_TYPE,
    SET_FILTER_ORDER_ALG,
    SET_FILTER_SDTIME_FROM,
    SET_FILTER_SDTIME_TO,
    SET_FILTER_FDTIME_FROM,
    SET_FILTER_IS_ROBOT_ORDER,
    SET_FILTER_CYCLE_END,
    SET_FILTER_CYCLE_STAGE,
    SET_FILTER_BASE_CURR,
    SET_FILTER_ORDER_ID_PAIRED_FROM,
    SET_FILTER_ORDER_ID_PAIRED_TO,
    SET_FILTER_FDTIME_TO, SET_PRICE_FROM, SET_PRICE_TO, SET_SHOW_BRUSH_FILTER, SET_PRICE_FROM_INIT, SET_PRICE_TO_INIT
} from '../types';
import {SET_TIME_TO, SET_TIME_FROM, SET_SORT, SET_SORT2, SET_SORT3, SET_GROUP, SET_SHOW_CANCELED_ORDERS} from '../types';
import {SET_CUSTOM_FIELDS, SET_TIMEFRAME_ACTIVE} from '../types';


import axios from 'axios';
import {timeFrom, timeTo} from "../../utils/timeInterval";
import {domain, naturalUrlAttr, ordersStructure, customFieldsList} from "../../config";

// Экшены на установку минимальной цены
export const setPriceFromInit = (data) => dispatch => {
    dispatch({type: SET_PRICE_FROM_INIT, payload: data});
};

// Экшены на установку максимальной цены
export const setPriceToInit = (data) => dispatch => {
    dispatch({type: SET_PRICE_TO_INIT, payload: data});
};

// Экшены на установку показа фильтров
export const setShowBrushFilter = (data) => dispatch => {
    dispatch({type: SET_SHOW_BRUSH_FILTER, payload: data});
};
// Экшены на установку показа отмененных ордеров
export const setShowCanceledOrders = (data) => dispatch => {
    dispatch({type: SET_SHOW_CANCELED_ORDERS, payload: data});
};

// Экшены на установку сортировки
export const setSort = (data) => dispatch => {
    dispatch({type: SET_SORT, payload: data});
};
// Экшены на установку сортировки
export const setSort2 = (data) => dispatch => {
    dispatch({type: SET_SORT2, payload: data});
};
// Экшены на установку сортировки
export const setSort3 = (data) => dispatch => {
    dispatch({type: SET_SORT3, payload: data});
};

// Экшены на установку группировки
export const setGroup = (data) => dispatch => {
    dispatch({type: SET_GROUP, payload: data});
};

// Экшены на общие настройки
export const setTimeFrom = (data) => dispatch => {
    dispatch({type: SET_TIME_FROM, payload: data});
};

export const setTimeTo = (data) => dispatch => {
    dispatch({type: SET_TIME_TO, payload: data});
};

export const setPriceFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_PRICE_FROM, payload: data});
};

export const setPriceTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_PRICE_TO, payload: data});
};

export const setTimeframe = (data) => dispatch => {
    dispatch({type: SET_TIMEFRAME_ACTIVE, payload: data});
};


// Экшены на фильтры интежеры
export const setFiltertxCNTFrom = (data) => dispatch => {
    dispatch({type: SET_TXCNT_FROM, payload: data});
};

export const setFiltertxCNTTo = (data) => dispatch => {
    dispatch({type: SET_TXCNT_TO, payload: data});
};

export const setFilterIterBuyFrom = (data) => dispatch => {
    dispatch({type: SET_ITER_BUY_FROM, payload: data});
};

export const setFilterIterBuyTo = (data) => dispatch => {
    dispatch({type: SET_ITER_BUY_TO, payload: data});
};

export const setFilterIterSellFrom = (data) => dispatch => {
    dispatch({type: SET_ITER_SELL_FROM, payload: data});
};

export const setFilterIterSellTo = (data) => dispatch => {
    dispatch({type: SET_ITER_SELL_TO, payload: data});
};

export const setFilterTargIdxFrom = (data) => dispatch => {
    dispatch({type: SET_TARG_IDX_FROM, payload: data});
};

export const setFilterTargIdxTo = (data) => dispatch => {
    dispatch({type: SET_TARG_IDX_TO, payload: data});
};

export const setFilterorderIdFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_ID_FROM, payload: data});
};

export const setFilterorderIdTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_ID_TO, payload: data});
};


export const setFilterOrderIdPairedFrom = (data) => dispatch => {
    dispatch({type: SET_FILTER_ORDER_ID_PAIRED_FROM, payload: data});
};

export const setFilterOrderIdPairedTo = (data) => dispatch => {
    dispatch({type: SET_FILTER_ORDER_ID_PAIRED_TO, payload: data});
};

// Экшены фильтров флотов
export const setFilteramountForOperFrom = (data) => dispatch => {
    dispatch({type: SET_AMOUNT_FOR_OPER_FROM, payload: data});
};
export const setFilteramountForOperTo = (data) => dispatch => {
    dispatch({type: SET_AMOUNT_FOR_OPER_TO, payload: data});
};
export const setFilterorderAmountForOperExecFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_AMOUNT_FOR_OPER_EXEC_FROM, payload: data});
};
export const setFilterorderAmountForOperExecTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_AMOUNT_FOR_OPER_EXEC_TO, payload: data});
};
export const setFilterorderPriceFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_PRICE_FROM, payload: data});
};
export const setFilterorderPriceTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_PRICE_TO, payload: data});
};
export const setFilterorderOrigAmountFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_ORIG_AMOUNT_FROM, payload: data});
};
export const setFilterorderOrigAmountTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_ORIG_AMOUNT_TO, payload: data});
};
export const setFilterorderAmountFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_AMOUNT_FROM, payload: data});
};
export const setFilterorderAmountTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_AMOUNT_TO, payload: data});
};
export const setFilterorderExecFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_EXEX_FROM, payload: data});
};
export const setFilterorderExecTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_EXEX_TO, payload: data});
};
export const setFilterfeeResultFrom = (data) => dispatch => {
    dispatch({type: SET_FEE_RESULT_FROM, payload: data});
};
export const setFilterfeeResultTo = (data) => dispatch => {
    dispatch({type: SET_FEE_RESULT_TO, payload: data});
};
export const setFilterorderRemainsFrom = (data) => dispatch => {
    dispatch({type: SET_ORDER_REMAINS_FROM, payload: data});
};
export const setFilterorderRemainsTo = (data) => dispatch => {
    dispatch({type: SET_ORDER_REMAINS_TO, payload: data});
};


// Экшены фильтров селектов
export const setFilterSide = (data) => dispatch => {
    dispatch({type: SET_FILTER_SIDE, payload: data});
};

export const setFilterStatus = (data) => dispatch => {
    dispatch({type: SET_FILTER_STATUS, payload: data});
};

export const setFilterType = (data) => dispatch => {
    dispatch({type: SET_FILTER_TYPE, payload: data});
};

export const setFilterOrderAlg = (data) => dispatch => {
    dispatch({type: SET_FILTER_ORDER_ALG, payload: data});
};

export const setFilterIsRobotOrder = (data) => dispatch => {
    dispatch({type: SET_FILTER_IS_ROBOT_ORDER, payload: data});
};

export const setFilterCycleEnd = (data) => dispatch => {
    dispatch({type: SET_FILTER_CYCLE_END, payload: data});
};

export const setFilterCycleStage = (data) => dispatch => {
    dispatch({type: SET_FILTER_CYCLE_STAGE, payload: data});
};

export const setFilterBaseCurr = (data) => dispatch => {
    dispatch({type: SET_FILTER_BASE_CURR, payload: data});
};

// Экшены фильтров дат
export const setFilterSdTimeFrom = (data) => dispatch => {
    dispatch({type: SET_FILTER_SDTIME_FROM, payload: data});
};

export const setFilterSdTimeTo = (data) => dispatch => {
    dispatch({type: SET_FILTER_SDTIME_TO, payload: data});
};

export const setFilterFdTimeFrom = (data) => dispatch => {
    dispatch({type: SET_FILTER_FDTIME_FROM, payload: data});
};

export const setFilterFdTimeTo = (data) => dispatch => {
    dispatch({type: SET_FILTER_FDTIME_TO, payload: data});
};

export const getFields = () => async dispatch => {
    try {
        const response = await axios.get(`${domain}user/trade/fields?${naturalUrlAttr}`);

        let list = {};
        Object.assign(list, customFieldsList);

        for (let key in list) {
            if (response.data.fields.indexOf(key) !== -1) {
                list[key] = true;
            }
        }

        dispatch({
            type: SET_CUSTOM_FIELDS,
            payload: list
        });
    } catch (e) {
        console.log('error custom fields');
    }
};

export const setCustomFields = (customFields) => dispatch => {
    dispatch({
        type: SET_CUSTOM_FIELDS,
        payload: customFields
    });
};

export const saveFields = customFields => {

    let fields = [];

    for (let field in customFields) {
        if (customFields[field]) {
            fields.push(field);
        }
    }

    const response = axios.post(`${domain}user/trade/fields?${naturalUrlAttr}`, {
        fields: fields
    }).then(data => {

        }
    ).catch(data => {

        }
    );
};
